import { createStyles } from 'antd-style'

/**
 * The grid shrinks with the window so the centered modal never outgrows the
 * viewport: the chrome around it (header, search, colours, footer) is ~330px.
 */
const VIEWPORT_HEIGHT = 'clamp(200px, calc(100vh - 300px), 440px)'

const SWATCH_SIZE = 20

const MODAL_PADDING = 16

export const useStyles = createStyles(({ token }) => ({
  modal: {
    '.ant-modal-container': {
      padding: MODAL_PADDING
    }
  },
  viewport: {
    height: VIEWPORT_HEIGHT,
    overflowY: 'auto',
    overscrollBehavior: 'contain',
    padding: token.paddingXXS,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG
  },
  placeholder: {
    height: VIEWPORT_HEIGHT,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG
  },
  rows: {
    position: 'relative',
    width: '100%'
  },
  row: {
    position: 'absolute',
    top: 0,
    left: 0,
    display: 'grid',
    width: '100%'
  },
  cell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    height: '100%',
    padding: 4,
    background: 'transparent',
    border: '1px solid transparent',
    borderRadius: token.borderRadiusLG,
    cursor: 'pointer',
    transition: `background ${token.motionDurationMid}, border-color ${token.motionDurationMid}`,

    '&:hover': {
      background: token.colorFillTertiary
    },

    '&:focus-visible': {
      outline: `2px solid ${token.colorPrimaryBorderHover}`,
      outlineOffset: -2
    }
  },
  cellSelected: {
    background: token.controlItemBgActive,
    borderColor: token.colorPrimary
  },
  cellLabel: {
    maxWidth: '100%',
    overflow: 'hidden',
    fontSize: 10,
    lineHeight: 1.4,
    color: token.colorTextTertiary,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  cellLabelSelected: {
    color: token.colorPrimary
  },
  tabs: {
    alignSelf: 'flex-start'
  },
  dropZone: {
    padding: token.paddingSM
  },
  photoPreview: {
    width: 96,
    height: 96,
    objectFit: 'cover',
    borderRadius: token.borderRadiusLG,
    border: `1px solid ${token.colorBorderSecondary}`
  },
  swatch: {
    width: SWATCH_SIZE,
    height: SWATCH_SIZE,
    padding: 0,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: '50%',
    cursor: 'pointer',
    transition: `box-shadow ${token.motionDurationMid}`,

    '&:focus-visible': {
      outline: `2px solid ${token.colorPrimaryBorderHover}`,
      outlineOffset: 2
    }
  },
  swatchSelected: {
    borderColor: token.colorBgContainer,
    boxShadow: `0 0 0 2px ${token.colorPrimary}`
  }
}))
